import gsap from 'gsap';
import Sine from 'gsap';

export function handleDetailClick(detailsButton, closeButton, detailsText ,detail){
    if(!detail){
        closeButton.classList.remove('showbottom');
        detailsButton.classList.add('showbottom');
        const to = detailsText.clientWidth*2;
        gsap.to(detailsText, {
            x: to,
            duration: 0.5,
            ease: Sine.easeInOut
        })
    }else{
        detailsButton.classList.remove('showbottom');
        closeButton.classList.add('showbottom');
        const to = closeButton.style.right;
        gsap.to(detailsText, {
            x: to,
            duration: 0.5,
            ease: Sine.easeInOut
        })
    }
}